import React from "react";
import { motion } from "framer-motion";

export const Compliance = (props) => {
  return (
    <motion.div
      id="compliance"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container">
        <motion.div
          className="section-header-modern text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="section-tag"><i className="fa fa-certificate"></i> Licensed &amp; Compliant</span>
          <h2>Our Regulatory Standing</h2>
          <p>Transwave operates under a valid commercial license, fully compliant with UAE logistics and freight regulations.</p>
        </motion.div>
        <motion.div
          className="compliance-main-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          <div className="compliance-main-icon">
            <i className="fa fa-shield"></i>
          </div>
          <div className="compliance-main-body">
            <h3>Licensed &amp; Authorized Operations</h3>
            <p>
              Transwave Shipping and Logistics LLC operates under a valid commercial license issued by SHAMS (Sharjah Media City), UAE. All services are conducted in strict accordance with approved logistics, freight forwarding, cargo handling, and transportation support activities as authorized under UAE commercial law.
            </p>
            <div className="compliance-badges">
              <span className="compliance-badge"><i className="fa fa-check-circle"></i> UAE Licensed</span>
              <span className="compliance-badge"><i className="fa fa-check-circle"></i> SHAMS Authorized</span>
              <span className="compliance-badge"><i className="fa fa-check-circle"></i> Fully Compliant</span>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};
